import { Image, Text } from '@ui/atoms';
import React from 'react';
import texts from '@components/Homepage/en.json';

const BondPyramidSection = () => {
    const bondsData = [
        {
            goal: 'Bets',
            assets: "<span class='p4-semibold'>Junk Bonds,</span> Crypto, Options, Futures, Small Cap Stocks, Metals",
        },
        {
            goal: 'Growth Focused',
            assets: "<span class='p4-semibold'>High yield bonds,</span> MFs, Growth Stocks, <span class='p4-semibold'>SDIs,</span> Real Estate",
        },
        {
            goal: 'Balance Growth & Income',
            assets: `<span class='p4-semibold'>Investment grade corporate bonds, SDIs,</span> Blue chip stocks, MFs`,
        },
        {
            goal: 'Income Focused',
            assets: `<span class='p4-semibold'>High Rated Corporate Bonds, Govt. Bonds</span>`,
        },
        {
            goal: 'Preservation',
            assets: `<span class='p4-semibold'>Govt. Bonds, FDs,</span> Savings`,
        },
    ];
    return (
        <div className="flex flex-col gap-10 px-4 py-10 md:pt-8 md:pb-18 lg:px-16">
            <div className="flex flex-col gap-4 md:items-center">
                <Text
                    content={texts.BondsPyramidTitle}
                    className="h4-semibold md:h2-semibold text-transparent bg-blue-gradient bg-clip-text"
                />
                <Text
                    content={texts.BondsPyramidDescription}
                    className="p4-regular md:p3-medium text-gray-700"
                />
            </div>
            <Image
                src="/images/homepage/chart-container.webp"
                alt="bonds-pyramid"
                className="hidden sm:inline-block w-full max-w-[792px] self-center"
            />
            <div className="flex flex-col gap-6">
                <Image
                    src="/images/homepage/chart-container-mobile.webp"
                    alt="bonds-pyramid"
                    className="w-full self-center sm:hidden"
                />
                <div className="sm:hidden flex flex-col border-1 border-gray-200 rounded-xl overflow-hidden">
                    <div className="flex">
                        <Text
                            className="p-2 h6-semibold text-primary-500 border-b-1 border-r-1 border-gray-200 w-1/3"
                            content={'Goal'}
                        />
                        <Text
                            className="p-2 h6-semibold text-primary-500 border-b-1 border-gray-200 flex-1"
                            content={'Assets'}
                        />
                    </div>
                    {bondsData.map((bond, index) => (
                        <div className="flex">
                            <Text
                                className={`p-2 p4-semibold text-primary-300 border-r-1 ${
                                    index + 1 !== bondsData.length
                                        ? 'border-b-1 border-gray-200'
                                        : ''
                                } w-1/3`}
                                content={bond.goal}
                            />
                            <Text
                                className={`p-2 p4-regular text-gray-700 ${
                                    index + 1 !== bondsData.length
                                        ? 'border-b-1 border-gray-200'
                                        : ''
                                } flex-1`}
                                content={bond.assets}
                                isInnerHtml
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BondPyramidSection;
